import { Link } from "react-router-dom";
import { categories } from "@/mocks/games";
import SectionHeader from "@/components/feature/SectionHeader";

export default function HomeCategories() {
  return (
    <section aria-label="游戏分类快捷入口">
      <SectionHeader
        eyebrow="快速入口"
        title="按分类找到你想玩的游戏"
        subtitle="竞技对战、角色扮演、休闲益智等多个大类，点击即可进入对应分类浏览与筛选。"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((category) => (
          <Link
            key={category.key}
            to={`/category/${category.key}`}
            className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition duration-300 hover:-translate-y-1 hover:border-primary-200 md:p-5"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${category.icon} text-2xl`}></i>
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center justify-between">
                <span className="text-base font-bold text-foreground-900">{category.name}</span>
                <i className="ri-arrow-right-up-line text-foreground-300 transition group-hover:text-primary-500"></i>
              </span>
              <span className="mt-1.5 block text-sm leading-relaxed text-foreground-500">{category.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}